import React, {useEffect, useState} from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import Moment from 'react-moment';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import RegisterButton from "../RegisterButton/RegisterButton";
import {Alert} from "@mui/material/";

export interface IPlace {
  title: string,
  addressLine1: string,
  postalCode: string,
  locality: string,
  images: any,
  uuid: string,
}

export interface IEvent {
  uuid: string,
  starts: string,
  ends: string,
  title: string,
  description?: string,
  seats: number,
  seatsAvailable: number,
  image: any,
}

export interface IEventData {
  id: string,
  place?: IPlace,
  events?: IEvent[],
}


export interface IEventListProps {
  event: string,
  closingDate: string
}

export interface IEventListState {
  isLoading: boolean,
  eventData: IEventData,
}



const EventList = (props: IEventListProps) => {
  const [eventData, setEventData] = useState<IEventData>({id: ""});
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    var getUrl = window.location;
    var baseURL = getUrl .protocol + "//" + getUrl.host;
    if (baseURL == 'http://localhost:3000') {
      baseURL = 'https://buxliest.local.computer';
    }
    axios.get(baseURL + "/bux-api/bux-event/event-data/" + props.event + "?_format=json", {
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((result) => {
        setEventData(result.data);
      })
      .catch(error => {
        if (error.response) {
          console.log(error.responderEnd);
        }
      });
  }

  const handleSnackbarClose = (event: any) => {
    setSnackbarOpen(false);
  };

  const addAttendeeSuccess = () => {
    setSnackbarOpen(true);
    loadData();
  };

  const date = new Date();
  const closingDate = new Date(props.closingDate);
  const closed = date.getTime() > closingDate.getTime();

  console.log({date:date, closingDate:closingDate, closed:closed});

  return (
    <Box>
      {eventData.place && eventData.events && (
        <Box className="w-full">
          <Box className="flex flex-col md:flex-row bg-gray-100 mb-4 ml-4">
            {eventData.place?.images?.length > 0 &&
            <Box className="pr-10">
              <img className="block max-w-[200px]" src={eventData.place?.images[0].thumbnail.url}/>
            </Box>
            }
            <Box className="">
              <Box className="text-xl mt-4 mb-2 text-primary-600">{eventData.place?.title}</Box>
              <Typography>{eventData.place?.addressLine1},&nbsp;
                {eventData.place?.postalCode}&nbsp;
                {eventData.place?.locality}</Typography>
              {eventData.events.length > 0 &&
              <Moment format="DD.MM.YYYY" parse="YYYY-MM-DDTHH:mm:ss">
                {eventData.events[0].starts}
              </Moment>
              }
            </Box>
          </Box>

          <List className="" disablePadding>
            {eventData.events.map((item, index) =>
              <>
                <ListItem alignItems="flex-start" key={item.uuid}>
                  <ListItemText
                    disableTypography
                    primary={
                      <React.Fragment>
                        <Box className="text-primary-500 text-xl mb-2">
                          <Moment format="HH:mm U\hr" parse="YYYY-MM-DDTHH:mm:ss">
                            {item.starts}
                          </Moment>
                        </Box>
                        <Box className="text-2xl font-bold mb-4">{item.title}</Box>
                      </React.Fragment>
                    }
                    secondary={
                      <React.Fragment>
                        {item?.image?.thumbnail &&
                        <Box className="float-left pt-2 pb-2 pr-4">
                          <img src={item?.image.thumbnail.url}/>
                        </Box>
                        }
                        <Box className="prose max-w-[800px]"
                          // variant="body1"
                          dangerouslySetInnerHTML={{
                            __html: item?.description?.toString().replaceAll("<p>&nbsp;</p>", "") ?? ""
                          }}
                        ></Box>

                        {!closed &&item.seatsAvailable > 0 && (
                          <Box className="text-secondary-500 clear-both mt-6 mb-4"><p>Noch {item.seatsAvailable} freie Plätze</p></Box>
                        )}
                        {!closed &&item.seatsAvailable <= 0 && (
                          <Box className="text-secondary-500 clear-both mt-6 mb-4"><p>Momentan sind keine Plätze frei. Sie können sich aber auf die Warteliste setzen.</p></Box>
                        )}
                        {!closed && (
                          <RegisterButton place={eventData.place} event={item}
                                          successCallback={addAttendeeSuccess}></RegisterButton>
                        )}
                        {closed && (
                          <Box className="text-secondary-500 clear-both mt-6"><p>Der Anmeldeschluss ist erreicht. Es besteht die
                            Möglichkeit, sich spontan vor Ort anzumelden - sofern für die Lesung noch Plätze frei sind.</p></Box>
                        )}
                        <Snackbar open={snackbarOpen} autoHideDuration={8000} onClose={handleSnackbarClose}>
                          <Alert onClose={handleSnackbarClose} severity="success">
                            Das hat funktioniert. Sie bekommen eine Bestätigung per E-Mail.
                          </Alert>
                        </Snackbar>
                      </React.Fragment>
                    }
                  />
                </ListItem>
                <Divider component="li"/>
              </>
            )}
          </List>
        </Box>
      )}
    </Box>
  );
}


export default EventList;

